import './index.scss';

type RadioButtonProps = {
  id: string;
  onChange?: () => void;
  isSelected?: boolean;
  defaultChecked? : boolean;
  label?: React.ReactNode;
  value?: string;
  className?: string;
  labelClass?: string;
  name?: string;
  labelId?: string;
}

const RadioButton = ({ id, onChange, isSelected, defaultChecked, label, value, className, name, labelClass,labelId }: RadioButtonProps) => {
  return (
    <div className="radioButton">
      <input id={id} onChange={onChange} value={value} type="radio" checked={isSelected} defaultChecked={defaultChecked} className={className} name={name} />
      <label htmlFor={id} id={labelId} className={labelClass}>{label}</label>
    </div>
  );
}

export default RadioButton;